import React from 'react'
import MissionVision from '../home/MissionVision'
import NewsAdvertisement from '../home/NewsAdvertisement'
import HomeReviews from '../home/HomeReviews'
import { Link } from "react-router-dom";


const VisionAndMission = () => {
    return (
        <>
           
      <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2 className="wow fadeInUp" data-wow-delay=".3s">Vision & Mission</h2>
              <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li><i className="fa-solid fa-chevron-right" /></li>
                <li>Vision & Mission</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <MissionVision />
      <NewsAdvertisement />
      <HomeReviews />


        </>
    )
}

export default VisionAndMission